import React, { useMemo, useState } from 'react';
import {
    CheckboxControl,
    Tableau,
    TableauBody,
    TableauCell,
    TableauHeader,
    TableauHeaderCell,
    TableauRow,
} from '@design-system-etat/dsfr-react';
import PropTypes from 'prop-types';

const TableauCeaf = ({ armes, toggleArme, armesSelectionnees }) => {
    const [ordreTri, setOrdreTri] = useState('ASC');
    const [champTri, setChampTri] = useState('statut');

    const donneesTriees = useMemo(() => {
        if (!armes) {
            return [];
        }
        return armes.sort((a, b) => {
            if (a[champTri] < b[champTri]) return ordreTri === 'ASC' ? -1 : 1;
            if (a[champTri] > b[champTri]) return ordreTri === 'ASC' ? 1 : -1;
            return 0;
        });
    }, [armes, ordreTri, champTri]);

    const entete = [
        { field: '', header: '' },
        { field: 'numeroEncodage', header: "Numéro d'encodage" },
        { field: 'numeroSerie', header: 'Numéro de série' },
        { field: 'type', header: 'Type' },
        { field: 'marque', header: 'Marque' },
        { field: 'modele', header: 'Modèle' },
        { field: 'canonUn', header: 'Calibre Canon 1' },
        { field: 'canonDeux', header: 'Calibre Canon 2' },
        { field: 'classement', header: 'Classement' },
        { field: 'classementUE', header: 'Classement UE' },
    ];

    return (
        <Tableau
            avecBordure
            role="table"
            caption="Ratelier du détenteur - Appuyer sur un entete pour trier la colonne associée"
            noCaption
        >
            <TableauHeader>
                <TableauRow>
                    {entete.map((title) => (
                        <TableauHeaderCell
                            ordreTri={champTri === title.field ? ordreTri : undefined}
                            onClick={() => {
                                if (champTri === title.field) {
                                    setOrdreTri((old) => (old === 'ASC' ? 'DESC' : 'ASC'));
                                } else {
                                    setOrdreTri('ASC');
                                    setChampTri(title.field);
                                }
                            }}
                            scope="col"
                            key={title.field}
                        >
                            {title.header}
                        </TableauHeaderCell>
                    ))}
                </TableauRow>
            </TableauHeader>
            <TableauBody>
                {donneesTriees.map((arme) => {
                    return (
                        <TableauRow key={arme.uniquid}>
                            <TableauCell>
                                <CheckboxControl
                                    checked={armesSelectionnees.includes(arme.uniquid)}
                                    id={`selectCEAF-${arme.numeroEncodage}`}
                                    aria-label={`Ajouter l'arme ${arme.numeroEncodage} à ma ceaf`}
                                    label=""
                                    name={`selectCEAF-${arme.numeroEncodage}`}
                                    onClick={() => toggleArme(arme)}
                                />
                            </TableauCell>
                            <TableauCell>{arme.numeroEncodage}</TableauCell>
                            <TableauCell>{arme.numeroCarcasse}</TableauCell>
                            <TableauCell>{arme.type}</TableauCell>
                            <TableauCell>{arme.marque}</TableauCell>
                            <TableauCell>{arme.modele}</TableauCell>
                            <TableauCell>{arme.calibreCanon}</TableauCell>
                            <TableauCell>{arme.calibreCanonDeux}</TableauCell>
                            <TableauCell>{arme.classement}</TableauCell>
                            <TableauCell>{arme.classementEuropeen}</TableauCell>
                        </TableauRow>
                    );
                })}
            </TableauBody>
        </Tableau>
    );
};

TableauCeaf.propTypes = {
    armes: PropTypes.array.isRequired,
    toggleArme: PropTypes.func.isRequired,
    armesSelectionnees: PropTypes.array.isRequired,
};

export default TableauCeaf;
